export default __webpack_public_path__ + "static/media/InsightsCopyOrange.ceae5f6e.svg";